export { default as DropZones } from "./DropZones";
